import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  SecurityContext,
} from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';

import { EventTypes } from 'src/app/core/constants/event-types';
import { LoggerService } from 'src/app/core/services/logger.service';
import { GetCustomerDomainByIdDto } from '../../../../core/api/models';
import { DesktopEnumDisplay } from '../../../../core/enums/display/desktop.display';
import { TranslationService } from '../../../../i18n/translation.service';
import { BaseIndexModule } from 'src/app/pages/shared/base/modules/base-index.module';


@Component({
    selector: 'app-domain-details',
    templateUrl: './domain-details.component.html',
    imports: [BaseIndexModule]
})
export class DomainDetailsComponent implements OnInit {
  //#region Properties

  fields = 'pages.customerDomains.form.fields.';
  title = 'pages.customerDomains.form.detailTitle';

  @Input('model') model: GetCustomerDomainByIdDto;
  @Output('closePage') output_closPage = new EventEmitter<boolean>();

  imagePath: any;

  public DesktopEnumDisplay: typeof DesktopEnumDisplay = DesktopEnumDisplay;

  //#endregion

  constructor(
    private _sanitizer: DomSanitizer,
    public translationService: TranslationService,
    protected loggerService: LoggerService
  ) {}

  ngOnInit() {
    try {
      this.imagePath = this._sanitizer.sanitize(
        SecurityContext.RESOURCE_URL,
        this._sanitizer.bypassSecurityTrustResourceUrl(this.model.logoSrc)
      );
    } catch (error) {
      this.loggerService.logError(
        'app-domain-details',
        error,
        EventTypes.infrastructure
      );
    }
  }

  onClose() {
    this.output_closPage.emit(true);
  }
}
